import { render, staticRenderFns } from "./SimpleFindPointDialog.vue?vue&type=template&id=3986c70c&scoped=true&"
import script from "./SimpleFindPointDialog.vue?vue&type=script&lang=js&"
export * from "./SimpleFindPointDialog.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFindPointDialog.vue?vue&type=style&index=0&id=3986c70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986c70c",
  null
  
)

export default component.exports